import React from 'react';
import { Icon } from './Icon.js';
export const IconLightSwitch = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M8 11H16", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M6.5 17H17.5", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M8 3L16 3L16 11L17.5 17L17.5 21L6.5 21L6.5 17L8 11L8 3Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconLightSwitch.js.map